import { type FC } from 'react';

import { Alert, AlertDescription, AlertTitle } from './ui/alert';

export interface StatusMessageProps {
  type: 'destructive' | 'success' | 'info' | 'warning';
  title: string;
  message: string;
  details?: string;
}

const StatusMessage: FC<StatusMessageProps> = ({
  type,
  title,
  message,
  details,
}) => (
  <Alert variant={type}>
    <AlertTitle>{title}</AlertTitle>
    <AlertDescription>
      {message}

      {details && <div>{details}</div>}
    </AlertDescription>
  </Alert>
);

export default StatusMessage;
